import { trackEvent } from '../../../../_common/client/tracking';
import { TrackData } from '../../../../tracking/client/event-data-types';
import { PaginationType } from './on-pagination-button-click';

export const sendTrackingEvent = (paginationType: PaginationType, newPageNumber: number) => {
    const trackingLabels: TrackData = { review_ReviewAction: ['paging'], review_ReviewPage: [newPageNumber] };
    switch (paginationType) {
        case PaginationType.FIRST:
            trackingLabels.review_ReviewPageJump = ['first'];
            break;
        case PaginationType.LAST:
            trackingLabels.review_ReviewPageJump = ['last'];
            break;
    }
    trackEvent(trackingLabels);
};
